<template>
  <router-link
    :to="linkTo"
    class="button"
	>
    <i v-if="this.icon != ''" :class="this.icon"></i>
    {{ this.msg }}
  </router-link>
</template>

<script>
export default {
	name: 'Button',
  props: [ 'msg', 'icon', 'link' ],
  computed: {
    /* If link is set, return link content, else return empty
    string to prevent error for undefined to-value */
    linkTo: function () {
      if(this.link != null) {
        return this.link
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.button {
  display: flex;
	align-items: center;
	justify-content: center;
	max-width: 90%;
	border-radius: 1.5em;
	cursor: pointer;
	font-size: 1rem;
	text-transform: uppercase;
	font-family: "Roboto", sans-serif;
	font-weight: bold;
	transition: all .5s;
  padding: 13px 25px;
  margin: 30px auto;

	&--primary {
		color: $white;
		background-color: $mediumGreen;

		&:hover {
			background-color: $lightGreen;
		}
	}

	&--secondary {
		background-color: white;
		color: $green;
		border: 3px solid $mediumGreen;

    &:hover {
      background-color: $mediumGreen;
      color: white;
    }
	}

	&--center {
		margin-left: auto;
		margin-left: auto;
	}

	&--short {
		width: 10em;
	}

  &--remove-btm-margin {
    margin-bottom: 0;
  }

  // Pushes i to the left.
  svg {
    margin-right: 10px;
  }
}
</style>
